package one.healthium.profile.navigation.update_name

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultUpdateNameComponent(
    componentContext: ComponentContext,
    private val onCloseClicked: () -> Unit,
    private val onNameUpdated: () -> Unit,
) : UpdateNameComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }

    override fun onNameUpdated() {
        onNameUpdated.invoke()
    }
}